import { defineComponent as _defineComponent } from 'vue'
import { useViewportUtilities } from "@/ts/utils/viewport-utilities";
import { useAnchorEvents } from "@/ts/utils/anchor-events";
import { onMounted } from "vue";
import AOS from "aos";
import "aos/dist/aos.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props, { expose }) {
  expose();

useViewportUtilities();
useAnchorEvents();

onMounted(() => {
    AOS.init({
        offset: 0, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 500, // values from 0 to 3000, with step 50ms
        easing: "ease", // default easing for AOS animations
        once: true, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
});

const __returned__ = { useViewportUtilities, useAnchorEvents, onMounted, AOS }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})